import { render, staticRenderFns } from "./FriendRequests.vue?vue&type=template&id=273e6058&"
import script from "./FriendRequests.vue?vue&type=script&lang=js&"
export * from "./FriendRequests.vue?vue&type=script&lang=js&"
import style0 from "./FriendRequests.vue?vue&type=style&index=0&id=273e6058&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports